import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'دکتر سیمین | مرجع آرایشی و بهداشتی و زیبایی.',
    title:'اولین مرجع علمی، پژوهشی، صنعتی و کاربردی محصولات آرایشی و بهداشتی  و زیایی در ایران',
    description: "",
    image: '',
    resumePdf: resume
}
